import type { TFunction } from 'i18next';

interface ExperienceEntry {
  title?: string;
  employerFamily?: string;
  startDate?: string;
  endDate?: string;
  isCurrent?: boolean;
}

function formatDateRange(startDate: string | undefined, endDate: string | undefined, isCurrent: boolean | undefined, t: TFunction): string {
  const toYearMonth = (d: string | undefined) => {
    if (!d) return null;
    const parts = d.substring(0, 7); // YYYY-MM
    return parts.length >= 7 ? parts : null;
  };

  const start = toYearMonth(startDate);
  const end = isCurrent ? t('helperProfileForm.present', 'Present') : toYearMonth(endDate);

  if (!start && !end) return t('helperProfileForm.dateRangeUnknown', 'Date range unknown');
  if (start && end) return `${start} – ${end}`;
  const unknown = t('helperProfileForm.dateRangeUnknown', 'Date range unknown');
  if (start) return `${start} – ${unknown}`;
  return `${unknown} – ${end}`;
}

export function formatExperienceSummary(entry: ExperienceEntry, t: TFunction): string {
  const title = entry?.title?.trim() || t('helperProfileForm.untitledRole', 'Untitled role');
  const employer = entry?.employerFamily?.trim() || '—';
  const range = formatDateRange(entry?.startDate, entry?.endDate, entry?.isCurrent, t);
  return `${title} · ${employer} · ${range}`;
}
